export default {
    allowedExtensions(state) {
        return state.allowedExtensions;
    },
    maxFileSize(state) {
        return state.maxFileSize;
    },
    fileSizeType(state) {
        return state.fileSizeType;
    },
    maxFileCount(state) {
        return state.maxFileCount;
    },
    selectedFiles(state) {
        return state.selectedFiles;
    },
    error(state) {
        return state.error;
    },
    isSuccessful(state){
        return state.isSuccessful;
    }
}
  